import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../dataManagement/uiDb/UiDb";
import { canCurate } from "../interfaces/OnboardingObject";
import { fetchCaptainSummary } from "../services/thunks/OnboardingThunk";
import genericUtility from "../services/utility/GenericUtility";

/**
 * Who may use "Save collection" (cart and listing-collection pages): curators
 * and admins only for now -- the only users with a place to see saved
 * collections (Admin -> Listing Collections). Same role checks as AdminProgram;
 * loads the captain summary once if nothing has yet.
 */
export function useCanSaveCollections(): boolean {
  const dispatch: AppDispatch = useDispatch();
  const isSignedIn = !!genericUtility.getCurrentUserId();
  const { captainStatus, summary } = useSelector((state: RootState) => state.onboarding);
  const isAdmin = !!useSelector((state: RootState) => state.profile.data?.admin);

  useEffect(() => {
    if (isSignedIn && captainStatus === "unknown") dispatch(fetchCaptainSummary());
  }, [isSignedIn, captainStatus, dispatch]);

  return isSignedIn && (isAdmin || (!!summary && canCurate(summary.role)));
}
